import {RespondBeneficiaryAddressSuggestionV4Request} from 'domain/usecases';
import {makeRespondBeneficiaryAddressSuggestionV4} from 'main/factories/usecases';

type PostRespondAddressSuggestionParams = Omit<
	RespondBeneficiaryAddressSuggestionV4Request,
	'signal'
> & {
	signal?: AbortSignal;
};

export async function postRespondAddressSuggestion(
	params: PostRespondAddressSuggestionParams,
): Promise<void> {
	return makeRespondBeneficiaryAddressSuggestionV4().post(params);
}
